// extracted by mini-css-extract-plugin
export var quantityInput = "_mo-0";